"use client";

import { useLang } from "@/hooks/use-lang";

import { ProcessingStatusData } from "../../services/chat-stream";
import { StatusDisplay } from "./StatusDisplay";

export const ProcessingStatusView = ({
  status,
}: {
  status: ProcessingStatusData[];
}) => {
  const { t } = useLang();
  return (
    <div className="space-y-4">
      <p>{t.winwingpt.processingDesc}</p>
      <StatusDisplay processingStatus={status} />
    </div>
  );
};
